<template>
    <div class="footer">
        <div class="foot_content normal-foot-content">
            <div class="foot_middle partner_foot_middle">
                <div class="wrap">
                    <div class="row fix">
                        <div class="col-lg-2 col-md-2 col-sm-2">
                            <h3>中国出发航线</h3>
                            <ul>
                                <li><a href="/rccl.cruise/cruisesearch/search" class="" rel="">全部航线</a></li>
                                <li><a href="/rccl.cruise/cruisesearch/search?offset=0&amp;saildays=6" class="" rel="">深度游航线</a></li>
                                <li><a href="/rccl.cruise/cruisesearch/search?offset=0&amp;saildates=2020-04,2020-05,2020-06" class="" rel="">超凡暖春航线</a></li>
                                <li><a href="/rccl.cruise/cruisesearch/search?offset=0&amp;tags=%e6%98%a5%e8%8a%82,%e7%ab%af%e5%8d%88,%e5%9b%bd%e5%ba%86,%e5%9c%a3%e8%af%9e%e8%8a%82,%e5%85%83%e6%97%a6,%e9%99%a4%e5%a4%95,%e6%83%85%e4%ba%ba%e8%8a%82,%e5%85%83%e5%ae%b5%e8%8a%82,%e4%ba%94%e4%b8%80,%e6%af%8d%e4%ba%b2%e8%8a%82,%e4%b8%83%e5%a4%95,%e4%b8%ad%e7%a7%8b,%e5%af%92%e5%81%87,%e6%9a%91%e5%81%87,%e8%b8%8f%e9%9d%92" class="" rel="">超凡假日航线</a></li>
                                <li><a href="/rccl.cruise/cruisesearch/search?offset=0&amp;tags=%e8%b6%85%e5%87%a1%e4%b8%9c%e4%ba%ac&amp;orderbysaildate=1" class="" rel="">精彩东京航线</a></li>
                                <li><a href="/content/faq" class="" rel="">常见问题</a></li>

                            </ul>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2">
                            <h3>海外出发航线</h3>
                            <ul>
                                <li><a href="https://www.rclrow.com/cruise/search" class="" rel="nofollow">全部航线</a></li>
                                <li><a href="https://www.rclrow.com/cruise/search?departurecodes=sin" class="" rel="nofollow">东南亚航线</a></li>
                                <li><a href="https://www.rclrow.com/cruise/search?departurecodes=mia,fll,pcn" class="" rel="nofollow">加勒比航线</a></li>
                                <li><a href="https://www.rclrow.com/cruise/search?departurecodes=bcn,rom,vce" class="" rel="nofollow">欧洲航线</a></li>
                                <li><a href="https://www.rclrow.com/cruise/search?offset=0&amp;departurecodes=sea,swd,yvr" class="" rel="nofollow">阿拉斯加航线</a></li>
                                <li><a href="https://www.rclrow.com/cruise/search?offset=0&amp;departurecodes=syd,bne" class="" rel="nofollow">澳新航线</a></li>

                            </ul>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2">
                            <h3>皇家船队</h3>
                            <ul>
                                <li><a href="https://www.rcclchina.com.cn/content/taste/ships/sc" class="" rel="">海洋光谱号(上海/香港)</a></li>
                                <li><a href="/content/taste/ships/vy" class="" rel="">海洋航行者号(天津)</a></li>
                                <li><a href="/content/taste/ships/qn" class="" rel="">海洋量子号(新加坡)</a></li>
                                <li><a href="/symphony-of-the-seas/index" class="" rel="">海洋交响号(迈阿密)</a></li>

                            </ul>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2">
                            <h3>皇家游轮体验</h3>
                            <ul>
                                <li><a href="/rccl.custompage/country/countrylist" class="" rel="">目的地/岸上观光</a></li>
                                <li><a href="/content/taste/taste" class="" rel="">超凡游轮体验</a></li>
                                <li><a href="/spectrum-of-the-seas/liveshow" class="" rel="">超凡童趣 海上历奇</a></li>
                                <li><a href="https://www.rcclchina.com.cn/privilege/goldensuite20" class="" rel="">皇家套房尊享</a></li>
                                <li><a href="/rccl.review/travel/tn-n-n-0-0-9.html" class="" rel="">游记攻略</a></li>
                                <li><a href="/mice" class="" rel="">会奖旅游</a></li>

                            </ul>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2">
                            <h3>皇家资讯</h3>
                            <ul>
                                <li><a href="/rccl.custompage/rcclnews" class="" rel="">新闻中心</a></li>
                                <li><a href="/Rccl.UserCenter/CustomerInfo/SignUpReward" class="" rel="">会员福利</a></li>
                                <li><a href="/content/brand/story" class="" rel="">品牌故事</a></li>
                                <li><a href="/mice" class="" rel="">商务会奖</a></li>
                                <li><a href="/rccl.hr/recruitment/index" class="" rel="">人才招聘</a></li>

                            </ul>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2">
                            <h3>已有预订</h3>
                            <ul>
                                <li><a href="/content/faq" class="" rel="">常见问题</a></li>
                                <li><a href="/rccl.booking/booking/bookingsearch" class="" rel="">订单查询</a></li>
                                <li><a href="https://www.rclolci.com/rccl.olci/olci/checkinindex" class="" rel="nofollow">在线值船</a></li>
                                <li><a href="/content/brand/passenger/repeat" class="" rel="">票据合同</a></li>
                                <li><a href="http://www.pcprcl.com/rccl.pcp/?hmsr=rcclchinapcweb&amp;hmpl=topbar" class="" rel="nofollow">皇家行前订</a></li>

                            </ul>
                        </div>

                        <div class="col-lg-2 col-md-2 col-sm-2">
                            <h3><a href="/contactUs" style="color: white; font-size: 14px">联系我们</a></h3>
                            <ul>
                                <li class="footer__txt phoneCall_info" id="bottom_callcenter_phone"><a href="javascript: void(0)" @click="handlerShow">400-820-7195</a><ServiceTel :showMask="isShowMask" @closeMask="handlerClose"></ServiceTel></li>
                                <li><a href="javascript: void(0)" onclick="window.open('http://rcclchina.udesk.cn/im_client/?web_plugin_id=23600', 'newwindow', 'height=400, width=400')">在线客服</a></li>
                                <li><a href="http://weibo.com/rcclchina" target="_blank" rel="nofollow">官方微博</a></li>
                                <li class="weixin__linkPic footer__txt">
                                    官方微信
                                    <div class="weixin__container">
                                        <div class="arrow"></div>
                                        <div class="service_code">
                                            <img src="https://www.rcclchina.com.cn/Themes/Rccl.NewTheme/image/navi/weixin.jpg" alt="">
                                            <p>官方服务号</p>
                                        </div>
                                    </div>
                                </li>
                                <li><a href="https://www.pcprcl.com/privilege/pcp/royalapp" rel="nofollow">下载皇家APP</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot_bottom partner_foot_bottom">
                <div class="wrap">
                    <div class="row fix">
                        <div class="col-sm-3">
                            <a href="/"><img class="logo_bottom" src="https://resource.rcclchina.com.cn/Home/new/logo_bottom.png" alt="皇家加勒比国际豪华游轮"></a>
                        </div>
                        <div class="col-sm-9 col-lg-7 col-lg-offset-2">
                            <div class="right">
                                <a href="/content/brand/passenger/repeat" target="_blank">乘客票据合同（包括乘客行为守则和拒绝承运政策）</a><em>|</em><a href="/content/brand/legalinfo/repeat" target="_blank">法律声明</a><em>|</em><a href="/content/brand/legalinfo/privacy" target="_blank">隐私政策</a><em>|</em><a href="/content/brand/billofrights/repeat" target="_blank">邮轮业乘客权利法案</a>&nbsp;&nbsp;
                                <img src="http://www.rcclchina.com.cn/Themes/Rccl.NewTheme/image/navi/commerce.png" alt="">
                                <a rel="nofollow" href="https://www.sgs.gov.cn/lz/licenseLink.do?method=licenceView&amp;entyId=dov73ne26zbqq0ilalaqnc6x807hwf6byv">上海工商</a>
                            </div>
                            <div class="right">
                                皇家加勒比游轮船务（中国）有限公司版权所有<em>|</em><img src="http://www.rcclchina.com.cn/Themes/Rccl.NewTheme/image/navi/police.png" alt="">
                                <a rel="nofollow" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31022102000123" target="_blank">沪公网安备 31022102000123</a><em>|</em><a rel="nofollow" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备09065404号-1</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="foot_bottom partner_foot_bottom">
                <div class="wrap">
                    <div class="row fix">
                        <div class="col-sm-3">
                            <a href="/"><img class="logo_bottom" src="https://resource.rcclchina.com.cn/Home/new/logo_bottom.png" alt="皇家加勒比国际豪华游轮"></a>
                        </div>
                        <div class="col-sm-9 col-lg-7 col-lg-offset-2">
                            <div class="right">
                                <a href="/content/brand/legalinfo/repeat" target="_blank">法律声明</a><em>|</em><a href="/content/brand/legalinfo/privacy" target="_blank">隐私政策</a><em>|</em><img src="http://www.rcclchina.com.cn/Themes/Rccl.NewTheme/image/navi/commerce.png" alt="">
                                <a rel="nofollow" href="https://www.sgs.gov.cn/lz/licenseLink.do?method=licenceView&amp;entyId=dov73ne26zbqq0ilalaqnc6x807hwf6byv">北京工商</a>
                            </div>
                            <div class="right">
                                中旅途易旅游有限公司北京绿洲旅游分公司版权所有<em>|</em><img src="http://www.rcclchina.com.cn/Themes/Rccl.NewTheme/image/navi/commerce.png" alt="">
                                <a rel="nofollow" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31022102000120" target="_blank">京公安网备 11010102003723</a><em>|</em><a rel="nofollow" href="http://www.beian.miit.gov.cn" target="_blank">京ICP备19008609号</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>
    // import ServiceTel from '@/components/service-tel'
    export default {
        name: 'Footer',
        components: {
            // ServiceTel
        },
        data () {
            return {
                isShowMask: false
            }
        },
        methods: {
            handlerShow () {
                this.isShowMask = true
            },
            handlerClose (data) {
                this.isShowMask = data
            }
        }
    }
</script>

<style lang="less" scoped>
    .footer{
        color: #fff;
        .foot_content{
            position: relative;
            .foot_middle{
                padding: 35px 0;
                background-color: #051555;
                .col-lg-2{
                    float: left;
                    width: 14.22%;
                }
                .col-md-2{
                    padding: 0 5px;
                }
                h3{
                    border-bottom: none;
                    font-size: 15px;
                    padding-left: 14px;
                    padding-bottom: 0;
                    border-left: solid 2px #FFBD2E;
                    line-height: 1.1;
                }
                ul{
                    padding-left: 16px;
                    margin-top: 15px;
                    li{
                        border-bottom: none;
                        padding: 5px 0px;
                        color: #AEBAC4;
                        font-weight: 500;
                        font-size: 12px;
                        cursor: pointer;
                        a{
                            color: #AEBAC4;
                            font-weight: 500;
                        }
                        &:hover{
                            a{
                                color: #fbc500;
                            }
                        }
                    }
                    .weixin__linkPic{
                        position: relative;
                        .weixin__container{
                            position: absolute;
                            display: none;
                            top: 27px;
                            left: -7px;
                            width: 144px;
                            height: 150px;
                            background-color: #fff;
                            z-index: 1111;
                            -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
                            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
                            .service_code{
                                position: relative;
                                display: inline-block;
                                width: 100%;
                                height: 100%;
                                text-align: center;
                                img{
                                    position: relative;
                                    width: 100px;
                                    top: 10px;
                                    left: 0;
                                }
                                p{
                                    margin-top: 20px;
                                    color: #000f57;
                                    font-size: 14px;
                                }
                            }
                        }
                        &:hover{
                            .weixin__container{
                                display: block;
                            }
                        }
                    }
                }
            }
            .foot_bottom{
                background-color: #020f42;
                padding: 20px 0;
                color: #AEBAC4;
                .col-sm-3{
                    float: left;
                    .logo_bottom{
                        width: 181px;
                    }
                }
                .col-sm-9{
                    float: right;
                    .right{
                        margin-top: 10px;
                        font-size: 12px;
                        text-align: right;
                        a{
                            &:hover{
                                color: #fbc500;
                            }
                        }
                        em{
                            margin: 0 11px;
                        }
                        img{
                            vertical-align: middle;
                            margin: 0 3px;
                        }
                    }
                }
            }
        }
    }
</style>
